import React from 'react'

function Editor() {
  return (
    <div>Editor</div>
  )
}

export default Editor